module.exports = __webpack_public_path__ + "img/33.86895621.svg";